import React from 'react';
import Layout from '@/components/Layout';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const StoreLocatorPage = () => {
  const stores = [
    {
      name: "Bamo Tech Sphere Nairobi (Main Branch)",
      address: "Nairobi, Kenya",
      phone: "+254 703 207 300",
      email: "aethernexus05@gmail.com",
      hours: "Mon-Sat: 8:00 AM - 7:00 PM\nSunday: 10:00 AM - 5:00 PM",
      mapUrl: "https://www.google.com/maps/search/Nairobi+Kenya/@-1.286389,36.817223,12z"
    },
    {
      name: "Bamo Tech Sphere Meru Town",
      address: "Mosque Road, Near Bata\nMeru Town, Kenya",
      phone: "+254 703 207 300",
      email: "aethernexus05@gmail.com",
      hours: "Mon-Sat: 8:00 AM - 6:30 PM\nSunday: Closed",
      mapUrl: "https://www.google.com/maps/search/Mosque+Road+Meru+Kenya/@0.0500,37.6500,15z"
    },
    {
      name: "Bamo Tech Sphere Mombasa",
      address: "Msanifu Kombo Street\nOpposite County Public Health\nMombasa, Kenya",
      phone: "+254 703 207 300",
      email: "aethernexus05@gmail.com",
      hours: "Mon-Sat: 8:00 AM - 6:30 PM\nSunday: 10:00 AM - 4:00 PM",
      mapUrl: "https://www.google.com/maps/search/Msanifu+Kombo+Street+Mombasa/@-4.0500,39.6667,15z"
    }
  ];

  return (
    <Layout>
      <div style={{ background: 'var(--color-background)' }}>
        {/* Hero Section */}
        <section className="section-padding" style={{ background: 'var(--color-primary)' }}>
          <div className="container-custom text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6" style={{ color: 'var(--color-text-on-accent)' }}>
              Visit Our Stores
            </h1>
            <p className="text-xl max-w-3xl mx-auto" style={{ color: 'var(--color-text-on-accent)', opacity: 0.9 }}>
              Experience our products in person. Get expert advice, hands-on demos, and immediate pickup at any of our locations across Kenya.
            </p>
          </div>
        </section>

        {/* Stores List */}
        <section className="section-padding">
          <div className="container-custom">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {stores.map((store, idx) => (
                <Card key={idx} className="luxury-card">
                  <CardContent className="p-8">
                    <h3 className="text-2xl font-bold mb-6" style={{ color: 'var(--color-text-primary)' }}>
                      {store.name}
                    </h3>

                    <div className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <MapPin size={20} style={{ color: 'var(--color-accent)', marginTop: '2px' }} />
                        <div>
                          <p className="font-semibold mb-1" style={{ color: 'var(--color-text-primary)' }}>Address</p>
                          <p style={{ color: 'var(--color-text-secondary)', whiteSpace: 'pre-line' }}>{store.address}</p>
                        </div>
                      </div>

                      <div className="flex items-start space-x-3">
                        <Phone size={20} style={{ color: 'var(--color-accent)', marginTop: '2px' }} />
                        <div>
                          <p className="font-semibold mb-1" style={{ color: 'var(--color-text-primary)' }}>Phone</p>
                          <a href={`tel:${store.phone}`} style={{ color: 'var(--color-accent)' }} className="hover:underline">
                            {store.phone}
                          </a>
                        </div>
                      </div>

                      <div className="flex items-start space-x-3">
                        <Mail size={20} style={{ color: 'var(--color-accent)', marginTop: '2px' }} />
                        <div>
                          <p className="font-semibold mb-1" style={{ color: 'var(--color-text-primary)' }}>Email</p>
                          <a href={`mailto:${store.email}`} style={{ color: 'var(--color-accent)' }} className="hover:underline">
                            {store.email}
                          </a>
                        </div>
                      </div>

                      <div className="flex items-start space-x-3">
                        <Clock size={20} style={{ color: 'var(--color-accent)', marginTop: '2px' }} />
                        <div>
                          <p className="font-semibold mb-1" style={{ color: 'var(--color-text-primary)' }}>Hours</p>
                          <p style={{ color: 'var(--color-text-secondary)', whiteSpace: 'pre-line' }}>{store.hours}</p>
                        </div>
                      </div>
                    </div>

                    <a
                      href={store.mapUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-6 block"
                    >
                      <button className="luxury-button-primary w-full" data-testid={`view-map-${idx}`}>
                        View on Map
                      </button>
                    </a>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="section-padding" style={{ background: 'var(--color-background-secondary)' }}>
          <div className="container-custom">
            <h2 className="text-4xl font-bold mb-8 text-center" style={{ color: 'var(--color-text-primary)' }}>
              Our Locations
            </h2>
            <div className="rounded-2xl overflow-hidden" style={{ height: '500px', border: '1px solid var(--color-border)' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d255282.32374051595!2d36.70730744863279!3d-1.3028617517477308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f1172d84d49a7%3A0xf7cf0254b297924c!2sNairobi%2C%20Kenya!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Bamo Tech Sphere Locations"
              ></iframe>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default StoreLocatorPage;